var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.5C4.59953 12.5069 2.69868 10.7684 2.50296 8.50132C2.30724 6.23427 3.88202 4.19569 6.125 3.8125C9.6875 3.125 10.625 2.8 11.875 1.25C12.5 2.5 13.125 3.8625 13.125 6.25C13.125 9.6875 10.1375 12.5 6.875 12.5",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 13.125C1.25 11.25 2.40625 9.775 4.425 9.375C5.9375 9.075 7.5 8.125 8.125 7.5",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafBlack);
export default __webpack_public_path__ + "static/media/leaf-black.8ee6a7a66ea1f339056c6521f435548a.svg";
export { ForwardRef as ReactComponent };